import md5, { array } from 'js-md5';
import { ElNotification } from 'element-plus';
import { ElMessage } from 'element-plus'
import clipboard3 from  'vue-clipboard3'
var authresult={error:0,result:{status:0,msg:'',data:''}};
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
import INTERFACE_MODEL_Brand from '@/Interface/Es/Goods/Brand';
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
import INTERFACE_MODEL_CATE from '@/Interface/Es/Goods/Cates';
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';
import INTERFACE_MODEL_RENEW from '@/Interface/Es/Renew';
import INTERFACE_MODEL_SHIPPING from '@/Interface/Es/shipping';
import INTERFACE_MODEL_TUTARIAL from '@/Interface/Es/Tutarial';
import INTERFACE_MODEL_WALLET from '@/Interface/Es/wallet';
import INTERFACE_MODEL_XCX from '@/Interface/Es/xcx';
import INTERFACE_MODEL_PROMOTION from '@/Interface/Es/promotion';
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/pagelabel';

export default {

    /** 获取签名信息 **/
    GetSign(param) {
        //指定字符串
        let string='ttlsign'; 
        //删除无关字段
        delete(param.act);
        delete(param.token);
        //提取key进行排序
        var keys=Object.keys(param).sort(); 
        
        //拼接名称
        let names='';
        for(var i=0;i < keys.length;i++) names+=keys[i]+'='+param[keys[i]];
        console.log(names);
        names=md5(names);
        names+=string;
        names=md5(names);
        return names;        
    },


    /** 检查付费功能是否过期需要续费 **/
    CheckMenuIsAuth(data,controller,action) {
        //没有数据时直接返回成功
        if(!data) return {error:authresult.error,result:Promise.resolve(authresult.result)};
        if(controller=='' || action=='') return {error:authresult.error,result:Promise.resolve(authresult.result)};
        var auth_name=controller+'_'+action.toLowerCase();
        var Interfacedata=localStorage.getItem('InterfaceAuth'); 
        //没有登录时没有存储相关参数，返回成功
        if(!Interfacedata || Interfacedata=='') return {error:authresult.error,result:Promise.resolve(authresult.result)};
        Interfacedata=JSON.parse(Interfacedata);
        var authobj=Interfacedata[auth_name] ? Interfacedata[auth_name] : '';

        //操作权限没有具体方法时，直接返回成功
        if(auth_name=='') return {error:authresult.error,result:Promise.resolve(authresult.result)};
        //操作功能没在系统备注里时，直接返回成功
        if(authobj=='') return {error:authresult.error,result:Promise.resolve(authresult.result)};
        //操作权限为免费使用时，直接返回成功
        if(authobj.isfree==0) return {error:authresult.error,result:Promise.resolve(authresult.result)};
        //操作权限为按数据条数付费时，直接返回成功
        if(authobj.isfree==2) return {error:authresult.error,result:Promise.resolve(authresult.result)};
        
        //获取功能使用到期时间
        var expiretime=authobj.expiretime;  
        //获取当前使用时间                    
        var time=this.GetTimeNow();  
        //付费功能过期，输出提示                           
        if(time > expiretime) {
            var formattime=this.ChangeTimeFormat(expiretime);
            ElNotification({title:'错误提示',type:'warning',message:'当前功能已过期，请续费【过期时间：'+formattime+'】'}); //返回错误提示
            authresult.error=1000;
            authresult.result.status=1000;
            return {error:authresult.error,result:Promise.resolve(authresult.result)};
        }

        //其它正常情况，返回成功
        return {error:authresult.error,result:Promise.resolve(authresult.result)};
    },


    //获取当前时间戳
    GetTimeNow() {
        const currentTime = Date.now();
        const tenDigitTimestamp = Math.floor(currentTime / 1000);
        return tenDigitTimestamp;
    },


    //调整当前时间戳格式
    ChangeTimeFormat(time) {
        const expiretime=Date(parseInt(time) * 1000);
        const dateObj = new Date(expiretime);
        const year = dateObj.getFullYear(); // 年份
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // 月份（注意月份从0开始计算，所以加上1）
        const day = dateObj.getDate().toString().padStart(2, '0'); // 天数
        const hours = dateObj.getHours().toString().padStart(2, '0'); // 小时
        const minutes = dateObj.getMinutes().toString().padStart(2, '0'); // 分钟
        const seconds = dateObj.getSeconds().toString().padStart(2, '0'); // 秒数
        const formattedTimeStamp = `${year}-${month}-${day} ${hours}:${minutes}`;
        return formattedTimeStamp;
    },


    ////////////////////////////////////////////////////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////////////////////
    //初始化公共数据加载

    //获取教程一级分类信息
    GET_PLAT_VEDIO_CATE_PARENT(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('platvediocateparent');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_PLAT_VEDIO.GET_CATE_PARENT().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('platvediocateparent',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取教程全部分类信息
    GET_PLAT_VEDIO_CATE_ALL(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('platvediocateall');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_PLAT_VEDIO.GET_CATE_All().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('platvediocateall',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取VR数据
    GetVrFilePositionData() {
        const dateObj = new Date();
        const year = dateObj.getFullYear(); // 年份
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // 月份（注意月份从0开始计算，所以加上1）
        const day = dateObj.getDate().toString().padStart(2, '0'); // 天数
        const hours = dateObj.getHours().toString().padStart(2, '0'); // 小时
        const minutes = dateObj.getMinutes().toString().padStart(2, '0'); // 分钟
        const formattedTimeStamp = `${year}${month}${day}${hours}${minutes}`;
        const string=Math.floor(1000 + Math.random() * 9000);
        return formattedTimeStamp+string;
    },


    //复制内容到剪贴板操作
    CopyContentToClipboard(url) {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((resolve, reject) => {
            // 执行复制命令并移除文本框
            document.execCommand('copy') ? resolve() : reject(new Error('出错了'))
            textArea.remove();
        }).then(() => {
                ElNotification({title:'成功提示',message:'复制成功',type:'success'});
            },() => {
                ElNotification({title:'错误提示',message:'复制失败',type:'error'});
            }
        )
    },


    //生成商品编号
    CREATE_PNUMBER() {
        const string=Math.floor(100000 + Math.random() * 900000);
        return 'GOODS'+string;
    },


    //获取成色数据类型列表
    GET_GOODS_UNDER_LINE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('goodsunderline');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_GOODS.GET_GOODS_UNSER_LINE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('goodsunderline',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取成色数据类型列表
    GET_FINENESS(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('goodsfineness');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_GOODS.GET_GOODS_FINENESS().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('goodsfineness',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取销售类型数据类型列表
    GET_SALES_TYPES(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('goodstypes');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_GOODS.GET_GOODS_TYPES().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('goodstypes',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取会员类型信息
    GET_MEMBER_TYPES(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('membertypes');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_MEMBER_TYPES().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('membertypes',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取一级分类信息列表
    GET_CATES_PARENT(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('cateparentlist');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_CATE.GET_CATES_PARENT().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('cateparentlist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取二级分类信息列表
    GET_CATES_CHILD(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('catechildlist');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_CATE.GET_CATES_CHILD().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('catechildlist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取全部分类信息
    GET_CATES_ALL(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('cateall');    //获取浏览器缓存里的商品一级分类信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_CATE.GET_CATES_ALL().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('cateall',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取品牌信息
    GET_BRAND_ALL(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('brandlist');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_Brand.GET_BRAND_ALL({p:1,rollpage:100000}).then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('brandlist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取会员系统标识
    GET_MEMBER_SYS_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('membersyslist');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_MEMBER_SYS_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('membersyslist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取冻结时间类型
    GET_FROZEN_TIME_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('frozentimetype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_FROZEN_TIME().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('frozentimetype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //续费设置时间类型
    GET_RENEW_TIME_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('renewtimetype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_RENEW.GET_TIME_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('renewtimetype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //续费设置时间类型
    GET_SHIPPING_LIST(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('shippinglist');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_GOODS.GET_SHIPPING_LIST().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('shippinglist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取城市信息列表
    GET_CITY_LIST(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('citylist');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_GOODS.GET_CITY_LIST().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('citylist',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //续费设置时间类型
    GET_SHIPPING_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('shippingtype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_SHIPPING.GET_SHIPPING_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('shippingtype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取运费时间刻度
    GET_SHIPPING_TIME_SCALE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('shippingtimeScale');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_SHIPPING.GET_SHIPPING_TIME_SCALE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('shippingtimeScale',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取教程分类信息
    GET_TUTARIAL_CATES(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('tutarialcateinfos');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_TUTARIAL.GET_TUTARIAL_CATE_LIST({p:1,rollpage:10000}).then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('tutarialcateinfos',JSON.stringify(res.data.list ? res.data.list : []));
                reslove(res.data.list);
            });
        });
    },


    //会员信息列表
    GET_MEMBER_ALL(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('memberall');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_MEMBER_LIST({p:1,rollpage:10000000}).then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('memberall',JSON.stringify(res.data.list ? res.data.list : []));
                reslove(res.data.list);
            });
        });
    },


    //提现记录状态
    GET_WALLET_STATUS(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('walletstatus');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_WALLET.WALLET_STATUS().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('walletstatus',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //提现记录状态
    GET_JUMP_TYPES(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('jumptype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_XCX.GET_JUMP_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('jumptype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取认证类型
    GET_MEMBER_AUTH_TYPES(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('memberauthtype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_AUTH_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('memberauthtype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取会员认证状态信息
    GET_MEMBER_AUTH_LOG_STATUS(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('authverifystatus');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_MEMBER.GET_AUTH_LOG_STATUS().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('authverifystatus',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取置顶费用设置作用区域
    GET_RENEW_AREA_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('renewareatype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_RENEW.GET_AREA_TYPE().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('renewareatype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //获取管理页面数据标签
    GET_PAGE_LABEL_SETTING(type,isfresh=false) {
        return new Promise((reslove) => {
            var data=[];
            var model='pagelabel_'+type;
            var data=localStorage.getItem(model);    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_SHOP.GET_PAGE_LABEL({type:type}).then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem(model,JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },




    //获取推广渠道信息
    GET_PROMOTION_TYPE(isfresh) {
        return new Promise((reslove) => {
            var data=[];
            var data=localStorage.getItem('promotiontype');    //获取浏览器缓存里的品牌信息数据
            if(!isfresh && data && data!='') {reslove(JSON.parse(data));return false;} //非强制刷新时返回缓存数据

            //获取全部品牌信息数据
            INTERFACE_MODEL_PROMOTION.GET_PROMOTION_TYPE_LIST().then((res) => {
                if(res.status > 0) return false;
                localStorage.setItem('promotiontype',JSON.stringify(res.data ? res.data : []));
                reslove(res.data);
            });
        });
    },


    //数据排序
    // data 待排序的数组
    // sortcolumn {sortkey:sortvalue} sortkey-排序字段 sortvalue-排序方式 asc、升序 desc、降序
    DATA_SORT(data,sortcolumn) {
        if(data.length==0) return data;

        var sortinfo={};
        var sortdata;
        for(var i in sortcolumn) {
            sortinfo=sortcolumn[i];
            data.sort(function(a,b) {
                sortinfo=='asc' ? sortdata=a[i]-b[i] : sortdata=b[i]-a[i];
                return sortdata;
            });
        }
        return data;
    },


    //获取当前时间（1-天，2-月，3-年）
    GetNowTimes(type) {
        const dateObj = new Date();
        const year = dateObj.getFullYear(); // 年份
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // 月份
        const day = dateObj.getDate().toString().padStart(2, '0'); // 天数

        if(type==1) return `${year}-${month}-${day}`;
        if(type==2) return `${year}-${month}`;
        if(type==3) return `${year}`;
    },

    
    //获取当前时间往后推算的时间
    //@param type 1-天 2-月 3-年
    GetBeforeTimes(type,num) {
        let today = new Date();
        let yesterday = new Date(today);
        let yesterdayFormatted='';
        if(type==1) {
            yesterday.setDate(today.getDate() - num);
            yesterdayFormatted = yesterday.toISOString().split('T')[0];
        }else if(type==2) {
            yesterday.setMonth(today.getMonth() - num);
            yesterdayFormatted = yesterday.toISOString().substring(0,7);
        }else if(type==3) {
            yesterday.setFullYear(today.getFullYear() - num);
            yesterdayFormatted = yesterday.toISOString().substring(0,4);
        }
        return yesterdayFormatted;
    },


    //数据提交随机码
    //type 随机码类型 purch-进货单随机码
    GET_RADOM_CODE(type) {
        const title=type;
        const dateObj = new Date();
        const year = dateObj.getFullYear(); // 年份
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // 月份（注意月份从0开始计算，所以加上1）
        const day = dateObj.getDate().toString().padStart(2, '0'); // 天数
        const hours = dateObj.getHours().toString().padStart(2, '0'); // 小时
        const minutes = dateObj.getMinutes().toString().padStart(2, '0'); // 分钟
        const formattedTimeStamp = `${year}${month}${day}${hours}${minutes}`;
        const string=Math.floor(1000 + Math.random() * 9000);
        return title+formattedTimeStamp+string;
    },


    //数据小计计算
    CHAGNE_TOTAL(price,nums) {
        price && price > 0 ? '' : price=0;
        nums && nums > 0 ? '' : nums=1;
        price=parseFloat(price).toFixed(2);
        nums=parseFloat(nums).toFixed(2);
        var total=price*nums;
        return parseFloat(total).toFixed(2);
    },


    //复制文本信息
    COPY_TEXT(data) {
        if(data.title && data.title!='') {
            const { toClipboard } = clipboard3();
            toClipboard(data.title);
        }
        ElMessage({
            message:'复制成功',
            type:'success',
        });
    },

    

}